module.exports = __webpack_public_path__ + "img/paper_single.afc63178.jpg";